import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['copyButton'];

  resetButtons = (event) => {
    this.copyButtonTargets.forEach((element) => {
      if (event.detail.copiedValue !== element.dataset.clipboardToCopyValue) {
        element.removeAttribute('data-copied');
      }
    });
  };
}
